// extracted by mini-css-extract-plugin
export default {"contentBoxWrapper":"ContentBox_contentBoxWrapper__SrGfR","main":"ContentBox_main__EwHpn","mainInitLesson":"ContentBox_mainInitLesson__dIwya"};